<template>
    <q-btn
        color="primary"
        @click="modalOpened=true"
        label="Подключить услугу"
    >
        <q-modal
            v-model="modalOpened"
            content-css="width: 800px;"
        >
            <div class="services row no-wrap" style="height: 400px;">
                <div class="col services-col groups">
                    <div
                        class="services-list-item"
                        v-bind:class="group.id === services.selectedGroup ? 'is-active' : ''"
                        v-for="group in services.groups"
                        :key="group.id"
                        @click="serviceGroupChange(group.id)"
                    >
                        {{ group.name }}
                    </div>
                </div>
                <div class="col services-col items">
                    <div
                        class="services-list-item"
                        v-bind:class="item.id === services.selectedItem ? 'is-active' : ''"
                        v-for="item in services.items"
                        :key="item.id"
                        @click="serviceItemChange(item.id)"
                    >
                        {{ item.name }}
                    </div>
                </div>
                <div class="col services-col fields">
                    <q-field>
                        <q-datetime
                            v-model="service.validFrom"
                            minimal
                            stack-label="Дата подключения"
                        />
                    </q-field>
                    <q-field>
                        <q-select
                            v-if="serviceRequireAccuratePeriod(services.selectedItem)"
                            v-model="service.maxValidDays"
                            :options="maxValidDaysForService"
                            stack-label="Дней до истечения срока действия"
                        />

                        <q-input
                            v-else
                            v-model="service.maxValidDays"
                            stack-label="Дней до истечения срока действия"
                        />
                    </q-field>
                    <q-field>
                        <q-input
                            v-model="service.description"
                            minimal
                            stack-label="Описание"
                        />
                    </q-field>
                    <q-field>
                        <q-input
                            v-model="service.defaultAmount"
                            stack-label="Стоимость"
                        />
                    </q-field>

                    <span v-if="projectAssignedToNDSPayer" class="nds">* ПДВ 20% добавляется автоматически</span>
                </div>
            </div>
            <div class="row justify-end q-pa-lg">
                <q-btn
                    label="Отмена"
                    style="margin-right: 10px;"
                    @click="modalOpened=false"
                    :loading="service.loading"
                />
                <q-btn
                    label="Сохранить"
                    color="primary"
                    @click="addService"
                    :loading="service.loading"
                />
            </div>
        </q-modal>
    </q-btn>
</template>

<script>
import _ from 'lodash'

import {
    QBtn,
    QBtnToggle,
    QDatetime,
    QField,
    QIcon,
    QInput,
    QModal,
    QPopover,
    QSelect,
    QToggle,
    QTooltip,
} from 'quasar'

import columnsValues from '../HTable/columnsValues'
import { mapGetters } from 'vuex'

export default {
    name: 'ServiceCreate',
    components: {
        QField,
        QInput,
        QSelect,
        QBtn,
        QIcon,
        QTooltip,
        QPopover,
        QModal,
        QDatetime,
        QToggle,
        QBtnToggle,
    },

    data () {
        return {
            modalOpened: false,

            services: {
                data: {},
                groups: [],
                items: [],
                selectedGroup: null,
                selectedItem: null,
            },

            service: {
                id: null,
                validFrom: null,
                maxValidDays: null,
                paid: null,
                defaultAmount: null,
                description: null,
                loading: false,
            },

            maxValidDaysForService: columnsValues.maxValidDaysForService,
        }
    },

    computed: {
        ...mapGetters({
            project: 'project/data',
        }),

        projectAssignedToNDSPayer () {
            return this.project.service_provider.nds_payer === 1
        },
    },

    mounted () {
        this.fetchServices()
    },

    methods: {
        fetchServices () {
            this.$http.get(`api/v1.0/services/${this.$route.params.id}`).then(response => {
                _.forEach(response.data, (value, key) => {
                    this.services.groups.push({
                        name: value.name,
                        id: key,
                    })
                    //this.services.selectedGroup = this.services.groups[0].value;

                    //this.services.data[key] = [];
                    _.forEach(value.services, (value, key) => {
                        this.services.data[key] = value
                    })
                    //console.log(this.services.data);
                })
                this.serviceGroupChange(this.services.groups[0].id)

            }).catch(error => {

            })
        },

        serviceGroupChange (value) {
            this.services.selectedGroup = value
            this.services.items = _.filter(this.services.data, service => service.groupId === value)
            this.serviceItemChange(this.services.items[0].id)
        },

        serviceItemChange (value) {
            let date = new Date()
            this.services.selectedItem = value
            this.service = {
                validFrom: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
                maxValidDays: 'auto',
                defaultAmount: this.formatNumber(this.services.data[value].defaultAmount, 1 / 100),
            }
        },

        resolveMaxValidDays () {
            return this.service.maxValidDays === 'auto'
                ? null
                : (this.service.maxValidDays.includes('day') || this.service.maxValidDays.includes('month'))
                    ? this.service.maxValidDays
                    : `${this.service.maxValidDays} days`
        },

        addService () {
            this.service.loading = true
            let service = {
                'service_id': this.services.selectedItem,
                'valid_from': this.service.validFrom,
                'max_valid_days': this.resolveMaxValidDays(),
                'default_amount': this.formatNumber(this.service.defaultAmount, 100),
                'description': this.service.description,
            }
            this.$http.post(`api/v1.0/projects/${this.$route.params.id}/services`, service).then(response => {
                this.modalOpened = false
                this.$q.notify({ message: 'Сохранено', type: 'positive' })
                this.$emit('save')
            }).catch(error => {
                if (error.response.data.message) {
                    this.$q.notify({ message: error.response.data.message, type: 'negative' })
                }
                if (error.response.data.errors) {
                    _.forIn(error.response.data.errors, (value, key) => {
                        this.$q.notify({ message: value[0], type: 'negative' })
                    })
                }
            }).then(() => {
                this.service.loading = false
            })
        },

        formatNumber (value, factor) {
            return value * factor
        },

        serviceRequireAccuratePeriod (serviceId) {
            if (typeof serviceId !== 'string') {
                return false
            }

            return serviceId.includes('monthly')
                || serviceId.includes('cloud_2.0_demo')
                || serviceId.includes('cloud_2.0_personal')
        },
    },
}
</script>

<style scoped lang="scss">
.services {
    .q-field {
        margin-bottom: 14px;
    }

    .q-if {
        margin: 0;
    }
}

.services-col {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    padding: 9px 0;

    &.groups {
        background: #f9f9f9;
    }

    &.items {
        background: #f3f3f3;
    }

    &.fields {
        padding: 9px 16px;
        background: #eaeaea;
    }
}

.services-list-item {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 1rem;
    text-align: left;
    padding: 8px 16px;
    min-height: 40px;
    cursor: pointer;

    &:hover {
        color: var(--q-color-primary);
    }

    &.is-active {
        cursor: default;
        color: #000;

        .groups & {
            background: #f3f3f3;
        }

        .items & {
            background: #eaeaea;
        }
    }
}

.btn-toggle-label {
    margin-bottom: 4px;
    font-size: 0.75rem;
    line-height: 18px;
    color: #979797;
}

.nds {
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ServiceCreate/ServiceCreate.vue